var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 86,
    viewBox: "0 0 87 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.1286 36.0956L69.7148 27.1054C70.3043 26.7153 71.1168 26.8508 71.5294 27.4081C71.6826 27.6152 71.765 27.8618 71.765 28.1145V57.8725C71.765 58.5527 71.1815 59.1043 70.4619 59.1043C70.1946 59.1043 69.9337 59.0265 69.7148 58.8816L56.1286 49.8914V60.2383C56.1286 61.5989 54.9619 62.7018 53.5225 62.7018H17.0377C15.5984 62.7018 14.4316 61.5989 14.4316 60.2383V25.7487C14.4316 24.3881 15.5984 23.2852 17.0377 23.2852H53.5225C54.9619 23.2852 56.1286 24.3881 56.1286 25.7487V36.0956ZM56.1286 43.8772L66.5528 50.7751V35.2119L56.1286 42.1098V43.8772ZM19.6438 28.2122V57.7747H50.9165V28.2122H19.6438Z",
    fill: "#516CD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPermission);
export default __webpack_public_path__ + "static/media/CameraPermission.90041c2add770f399a7d2d29c4fa0897.svg";
export { ForwardRef as ReactComponent };